import { Flex, ScaleFade } from '@chakra-ui/react'

import { CustomFormQuestion } from 'components/tools/CustomForm/types'
import CustomFormViewerQuestion from 'components/tools/CustomForm/components/Viewer/components/CustomFormViewerQuestion'

type DemonstrationProps = {
  question: CustomFormQuestion
}

export default function Demonstration({ question }: DemonstrationProps) {
  return (
    <ScaleFade in={true}>
      <Flex flexDir="column" gap={2} border="1px solid" borderColor="borderColor" rounded="md" p={2} bg="light">
        <CustomFormViewerQuestion disabled question={question} index={0} questionsLength={1} />
      </Flex>
    </ScaleFade>
  )
}
